module.exports = __webpack_public_path__ + "img/cursor-box.fe883060.svg";